import React from "react";
import ReactDOM from "react-dom";
import RecentCarousel from "./containers/RecentCarousel";

const renderRecentCarouselApp = () => {
  const e = document.getElementById("recentCarouselWidget");
  if (e) {
    ReactDOM.render(<RecentCarousel {...e.dataset} />, e);
  }
};

renderRecentCarouselApp();



// WEBPACK FOOTER //
// ./src/recentCarousel.js